export default __webpack_public_path__ + "static/media/pokeball_not_found.18262ee6.gif";